<template>
  <div>
    <el-form :disabled="readonly" class="section top" style="flex-direction: row;min-width: 1600px;">
      <el-checkbox v-model="job.ams" no="4">AMS/ENS</el-checkbox>
      <el-checkbox v-model="job.heating" no="5">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="job.comercialInspectation" no="6">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="job.customs" no="7" @change="val=>{job.customsBroker=val?job.customsBroker:0;job.customsDeclarationType=val?job.customsDeclarationType:-1}">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
      <el-checkbox v-model="job.signMBL" no="8">MB/L</el-checkbox>
      <el-checkbox v-model="job.signHBL" no="9" :disabled="job.mblOnly">HB/L</el-checkbox>
      <el-checkbox v-model="job.mblOnly" no="10" @change="mblOnlyChange">{{ $t('Message.DirectBusiness') }}</el-checkbox>
      <el-checkbox v-model="job.salePrice" no="11">{{ $t('SeaExport.SpecialPrice') }}</el-checkbox>
      <el-checkbox v-model="job.availableCabinSpace" no="12">{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}</el-checkbox>
      <el-checkbox v-model="job.destinationPortService" no="destinationPortService" @change="destinationPortServiceChange">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <tab-se-booking-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.visible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input v-model="job.jobNo" no="12" :disabled="true" class="job-no-color input2" />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseNo.visible" slot="warehouseNo">
        <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
        <el-input v-model="job.warehouseNo" :disabled="readonly" no="13" class="input2" />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNo.visible" slot="quotationNo">
        <line-label slot="label" :class="elementDict.quotationNo.isRequire ? 'blue' : ''" :label="elementDict.quotationNo.label" />
        <el-input no="14" :value="job.quotationNo" class="input2" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.visible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="job.customerRefNo" :disabled="readonly" no="15" class="input2" :trim="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerId.visible" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <cargo-sales-company-select
          v-if="accountObjectControlMode === 2"
          no="16"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="flex: 1;"
          @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
        />
        <cargo-company-select
          v-else
          no="16"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :static-options="customerCmpList"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="flex: 1;"
          @change="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.visible" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <el-select
          v-model="job.customerContact"
          no="17"
          class="input2"
          :disabled="!electricBusinessBtnEnable || readonly"
          filterable
          :allow-create="true"
          placeholder=""
          @change="tfLinkman_closeHandler"
        >
          <el-option
            v-for="(item,index) in contactList"
            :key="index"
            :label="item.contactPerson"
            :value="item.contactPerson"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.contactTelephone.visible" slot="contactTelephone">
        <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
        <el-input
          v-model="job.contactTelephone"
          no="18"
          class="input2"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.contactFax.visible" slot="contactFax">
        <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
        <el-input
          v-model="job.contactFax"
          no="19"
          class="input2"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.sales.visible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          no="20"
          class="input2"
          :disabled="!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales))) || readonly"
          :method-params="{officeId:!isSpecifiedSalesBusiness&&salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="job.sales||''"
          :static-options="salesList"
          :placeholder="$t('SeaExport.RequiredItem')"
          @change="txtSales_changeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.visible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="21"
          class="input2"
          :disabled="!(job.sales>0&&job.salesDepartment>0) || readonly"
          :sales-id="job.sales"
          :office-id="job.salesOffice"
          :department-id="job.salesDepartment"
          :show-office-prefix="false"
          placeholder=" "
          @change="p=>{job.salesDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesCompany.visible" slot="salesCompany">
        <line-label slot="label" :class="elementDict.salesCompany.isRequire ? 'blue' : ''" :label="elementDict.salesCompany.label" />
        <el-input v-model="txtSalesOffice" no="22" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" class="input2" />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.visible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="23"
          class="input2"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
          :default-value="job.csr||''"
          :static-options="userPortRoleData.csr || csrList"
          placeholder=" "
          @change="csrChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.visible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          no="24"
          class="input2"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
          :default-value="job.op||''"
          placeholder=" "
          :static-options="userPortRoleData.op"
          @change="txtOPChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.visible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="25"
          class="input2"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :office-id="job.opOffice"
          :enables="true"
          :department-id="job.opDepartment"
          placeholder=" "
          @change="p=>{job.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.visible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-advance-select
          no="26"
          class="input2"
          :disabled="isEntrustOrder() || readonly"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.opOffice||''"
          placeholder=" "
          @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.visible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          no="27"
          class="input2"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
          :default-value="job.siteOP||''"
          placeholder=" "
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.visible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="28"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="job.cargoSalesId||''"
          :static-options="cargoSalesList"
          placeholder=" "
          @change="cargoSalesChargeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.visible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          no="29"
          class="input2"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
          :default-value="job.dc||''"
          :static-options="userPortRoleData.doc || dcList"
          placeholder=" "
          :merge-load="true"
          @change="dcChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.visible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="30"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="job.planner||''"
          placeholder=" "
          :static-options="userPortRoleData.seaLine"
          :merge-load="true"
          @change="txtPlannerChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.visible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          class="input2"
          :disabled="readonly"
          placeholder=" "
          :default-value="job.overseaOp||''"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          :merge-load="true"
          @change="p=>{
            job.overseaOp = p.value
            OverseaCustomerUtils.overseaOpChangeHandler(view, p)
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.visible" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(job.csrOffice)"
          :enables="true"
          :department-id="Number(job.csrDepartment)"
          @change="p=>{job.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.visible" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-advance-select
          no="csrOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.csrOffice||''"
          @parentCallBack="p=>{job.csrOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.visible" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(job.dcOffice)"
          :enables="true"
          :department-id="Number(job.dcDepartment)"
          @change="p=>{job.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.visible" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-advance-select
          no="dcOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.dcOffice||''"
          @parentCallBack="p=>{job.dcOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.visible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="31" class="input2" />
        <cargo-project-select
          v-if="openProjectConfig"
          no="32"
          :disabled="readonly"
          :default-value="job.poNo"
          :customer-id="job.customerId"
          :is-linked="isProjectLinkedCustomer"
          class="input2"
          @change="changeProject"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.visible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(job.plannerOffice)"
          :enables="true"
          :department-id="Number(job.plannerDepartment)"
          @change="p=>{job.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.visible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-advance-select
          no="plannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.plannerOffice||''"
          @parentCallBack="p=>{job.plannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.visible && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="job.projectName" no="33" :disabled="true" class="input2" />
      </el-form-item>
      <el-form-item v-if="elementDict.projectBatch.visible && openProjectConfig" slot="projectBatch">
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="job.projectBatch" :disabled="readonly" no="34" class="input2" />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId1.visible && isAddUserDefinedRoles" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          no="35"
          class="input2"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="job.userDefinedRoleId1||''"
          placeholder=" "
          :static-options="userPortRoleData.userDefinedRole1"
          :merge-load="true"
          @change="userDefinedRoleId1Handler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId2.visible && isAddUserDefinedRoles" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          no="36"
          class="input2"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="job.userDefinedRoleId2||''"
          placeholder=" "
          :static-options="userPortRoleData.userDefinedRole2"
          :merge-load="true"
          @change="userDefinedRoleId2Handler"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-remoteBooking-se-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-remoteBooking-se-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="job.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="job.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.visible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="job.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.visible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="job.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.visible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="job.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
          :disabled="readonly"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <!-- <el-form-item v-show="elementDict.bookingRefuseNote.visible && job.preverifyState===3" slot="bookingRefuseNote">
        <line-label slot="label" :class="elementDict.bookingRefuseNote.isRequire ? 'blue' : ''" :label="elementDict.bookingRefuseNote.label" />
        <el-input v-model="job.bookingRefuseNote" no="37" type="textarea" :rows="3" :disabled="true" />
      </el-form-item> -->
      <el-form
        v-show="elementDict.shipper.visible"
        slot="shipper"
        label-width="50px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
          <cargo-company-select
            no="38"
            :disabled="readonly"
            :method-params="{shipper:true,active:true}"
            :default-value="job.shipperId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
            style="display: inline-block;width:196px;"
            @change="shipperChange"
          />&nbsp;
          <el-button
            no="39"
            :disabled="readonly"
            type="primary"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'shipperLine'+i"
            v-model="job['shipperLine'+i]"
            :disabled="readonly"
            no="40"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.visible"
        slot="consignee"
        label-width="65px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
          <cargo-company-select
            no="66"
            :disabled="readonly"
            :method-params="{consignee:true,active:true}"
            :default-value="job.consigneeId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
            style="display: inline-block;width:196px;"
            @change="consigneeChange"
          />&nbsp;
          <el-button
            no="67"
            :disabled="readonly"
            type="primary"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'consigneeLine'+i"
            v-model="job['consigneeLine'+i]"
            :disabled="readonly"
            no="68"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.visible"
        slot="notify"
        label-width="50px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
          <cargo-company-select
            no="93"
            :disabled="readonly"
            :method-params="{notify:true,active:true}"
            :default-value="job.notifyId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
            style="display: inline-block;width:196px;"
            @change="notifyChange"
          />&nbsp;
          <el-button
            no="94"
            :disabled="readonly"
            type="primary"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'notifyLine'+i"
            v-model="job['notifyLine'+i]"
            :disabled="readonly"
            no="95"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true)"
          />
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.visible" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="job.alsoNotify"
          no="109"
          type="textarea"
          :rows="12"
          :disabled="readonly"
          class="also-notify"
          @dblclick.native="showAdvanceTextDialog(elementDict.alsoNotify.label,job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
        />
      </div>
      <el-form-item v-if="elementDict.etd.visible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <el-date-picker v-model="job.etd" :disabled="readonly" no="41" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" style="width: 100%;" @input="etdChange" />
      </el-form-item>
      <el-form-item v-if="elementDict.eta.visible" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <el-date-picker v-model="job.eta" :disabled="readonly" no="42" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%;" />
      </el-form-item>
      <div v-if="elementDict.customsDate && elementDict.customsDate.visible && $store.getters.enableFrontEndPlugin" slot="customsDate">
        <micro-app
          name="child-operation-date-se"
          :url="$store.getters.frontEndPluginUrl+'/operationDateItem'"
          router-mode="pure"
          destroy
          @datachange="operationDateDataChange"
        />
      </div>
      <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.visible && !$store.getters.enableFrontEndPlugin" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%;" />
      </el-form-item>
      <el-form-item v-if="elementDict.customCutoff.visible" slot="customCutoff">
        <line-label slot="label" :class="elementDict.customCutoff.isRequire ? 'blue' : ''" :label="elementDict.customCutoff.label" style="width: 100%;" />
        <el-date-picker
          v-model="job.customCutoff"
          :disabled="readonly"
          no="43"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.amsCutoff.visible && job.ams" slot="amsCutoff">
        <line-label slot="label" :class="elementDict.amsCutoff.isRequire ? 'blue' : ''" :label="elementDict.amsCutoff.label" />
        <el-date-picker
          v-model="job.amsCutoff"
          :disabled="readonly"
          no="44"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.returnPeriodBegin.visible" slot="returnPeriodBegin">
        <line-label slot="label" :class="elementDict.returnPeriodBegin.isRequire ? 'blue' : ''" :label="elementDict.returnPeriodBegin.label" />
        <el-date-picker
          v-model="job.returnPeriodBegin"
          :disabled="readonly"
          no="45"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.returnPeriodEnd.visible" slot="returnPeriodEnd">
        <line-label slot="label" :class="elementDict.returnPeriodEnd.isRequire ? 'blue' : ''" :label="elementDict.returnPeriodEnd.label" />
        <el-date-picker
          v-model="job.returnPeriodEnd"
          :disabled="readonly"
          no="46"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlace.visible" slot="dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
        <cargo-advance-select
          no="dispatchingPlaceCode"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          :placeholder="$t('SeaExport.PlaceHolderPOR')"
          filterable
          :default-value="job.dispatchingPlaceCode"
          tag-name="englishName"
          style="flex:1"
          @parentCallBack="changeDispatchingPlaceCode"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.visible" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <cargo-advance-select
            no="48"
            :disabled="readonly"
            filterable
            :select-type="TYPE_NAMES.basic_data_Seaport"
            :default-value="job.loadingPortCode"
            :placeholder="$t('SeaExport.RequiredItem')"
            class="port-item"
            @parentCallBack="loadingPortCode_Change"
          />
          <template v-if="elementDict.transferPortCode.visible">
                &nbsp;
            <el-checkbox v-model="job.transfering" :disabled="readonly" no="49" style="padding-left:2px;">{{ $t('SeaExport.Transit') }}</el-checkbox>
          </template>
        </div>
      </el-form-item>
      <!-- 中转港 -->
      <el-form-item v-if="elementDict.transferPortCode.visible && job.transfering" slot="transferPortCode">
        <line-label slot="label" :class="elementDict.transferPortCode.isRequire ? 'blue' : ''" :label="elementDict.transferPortCode.label" />
        <cargo-advance-select
          no="50"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="job.transferPortCode"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{job.transferPortCode = p.value}"
        />
      </el-form-item>
      <!-- 卸货港 -->
      <el-form-item v-if="elementDict.dischargingPortCode.visible" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          no="51"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="job.dischargingPortCode"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{dischargingPortCodeChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.visible" slot="destinationPortCode">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          no="52"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="job.destinationPortCode"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{destinationPortCode_Change(p);}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfDeliveryRegion.visible" slot="placeOfDeliveryRegion">
        <line-label slot="label" :class="elementDict.placeOfDeliveryRegion.isRequire ? 'blue' : ''" :label="elementDict.placeOfDeliveryRegion.label" />
        <cargo-advance-select
          no="117"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Region"
          filterable
          :default-value="job.placeOfDeliveryRegion"
          @parentCallBack="p=>{job.placeOfDeliveryRegion=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.visible" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input
          v-model="job.destinationPlace"
          :disabled="readonly"
          no="53"
          @change="changeDestinationPlace"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.visible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <cargo-advance-select
          no="54"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.local_cache_CargoSource"
          :default-value="job.cargoSource"
          :clearable="false"
          @parentCallBack="p=>{job.cargoSource=p.value;cargoSource_Change();txtCargoSourceChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.agentRefNo.visible && job.cargoSource === 'NC'" id="agentRefNo" slot="agentRefNo">
        <line-label slot="label" :class="elementDict.agentRefNo.isRequire ? 'blue' : ''" :label="elementDict.agentRefNo.label" />
        <el-input v-model="job.agentRefNo" :disabled="readonly" no="agentRefNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.customJobType.visible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="55"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_CutomJobType"
          :method-params="{type:job.lob, active: true}"
          :default-value="job.customJobType"
          :placeholder="$t('Message.PleaseSelect')"
          @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.visible" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <cargo-advance-select
          no="56"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          filterable
          :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
          :default-value="job.destinationAgent||''"
          placeholder=" "
          @parentCallBack="txtDestinationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.visible && job.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <cargo-company-select
          no="57"
          :disabled="readonly"
          :method-params="{designationAgent:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.designationAgent||''"
          tag-name="englishName"
          placeholder=" "
          @change="txtDesignationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.visible && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          no="58"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
          :default-value="job.bookingAgent || ''"
          placeholder=" "
          @parentCallBack="bookingAgentChangeHandler"
        />
      </el-form-item>
      <!-- 码头公司 -->
      <el-form-item v-if="elementDict.terminalCompany.visible" slot="terminalCompany">
        <line-label slot="label" :class="elementDict.terminalCompany.isRequire ? 'blue' : ''" :label="elementDict.terminalCompany.label" />
        <cargo-company-select
          no="terminalCompany"
          :disabled="readonly"
          :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
          :default-value="job.terminalCompany||''"
          style="width: 100%"
          @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
        />
      </el-form-item>
      <!-- 船公司 -->
      <el-form-item v-if="elementDict.carrierId.visible" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-advance-select
          no="59"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{seaCmp:true,companyLob:'seaExport',active:true}"
          :default-value="job.carrierId || ''"
          placeholder=" "
          @parentCallBack="carrierChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.scNo.visible" slot="scNo">
        <line-label slot="label" :class="elementDict.scNo.isRequire ? 'blue' : ''" :label="elementDict.scNo.label" />
        <el-input v-model="job.scNo" :disabled="readonly" no="60" />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.visible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="61"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_CargoType"
          :method-params="{sea:true}"
          :default-value="job.cargoType"
          :clearable="false"
          @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.visible" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-require-advance-select
          no="62"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_PaymentTerm"
          :default-value="job.paymentTermMBL"
          :clearable="false"
          @parentCallBack="p=>{job.paymentTermMBL=p.value;portChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfMblPayment.visible" slot="placeOfMblPayment">
        <line-label slot="label" :class="elementDict.placeOfMblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfMblPayment.label" />
        <el-input
          v-model="mblDoc.paymentPlaceBL"
          no="63"
          :disabled="job.paymentTermMBL==='CC'||job.paymentTermMBL==='PPAC' || readonly"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermHBL.visible && !job.mblOnly" slot="paymentTermHBL">
        <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
        <cargo-require-advance-select
          no="64"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="job.paymentTermHBL"
          @parentCallBack="p=>{job.paymentTermHBL=p.value;portChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfHblPayment.visible && !job.mblOnly" slot="placeOfHblPayment">
        <line-label slot="label" :class="elementDict.placeOfHblPayment.isRequire ? 'blue' : ''" :label="elementDict.placeOfHblPayment.label" />
        <el-input v-model="hdoc.paymentPlaceBL" :disabled="readonly" no="65" />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel.visible" slot="vessel">
        <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
        <cargo-advance-select
          no="69"
          :disabled="readonly"
          :select-type="TYPE_NAMES.static_data_Vessel"
          :cache="false"
          filterable
          :allow-create="true"
          :default-value="job.vessel"
          :static-options="vesselList"
          placeholder=" "
          @parentCallBack="onVesselSelectionChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.visible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <cargo-advance-select
          ref="voyageFlight"
          no="70"
          :disabled="readonly"
          :cache="false"
          filterable
          clearable
          :allow-create="true"
          :default-value="job.voyageFlight"
          tag-name="voyageNo"
          tag-value="voyageNo"
          :static-options="voyages"
          placeholder=" "
          @focus="txtVoyageFocusInHandler"
          @parentCallBack="p=>{job.voyageFlight=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselIMO.visible" slot="vesselIMO">
        <line-label slot="label" :class="elementDict.vesselIMO.isRequire ? 'blue' : ''" :label="elementDict.vesselIMO.label" />
        <el-input v-model="job.vesselIMO" :disabled="readonly" no="71" />
      </el-form-item>
      <template v-if="elementDict.bargeCustomCutoff.visible" slot="bargeCustomCutoff">
        <el-form-item>
          <line-label slot="label" :class="elementDict.bargeCustomCutoff.isRequire ? 'blue' : ''" :label="elementDict.bargeCustomCutoff.label" />
          <div style="display: flex">
            <el-checkbox v-model="showBargeCustomCutoff" :disabled="readonly" no="72" />
            <div v-show="showBargeCustomCutoff" style="margin-left: 10px">
              <span>{{ $t('Sales.Barge') }}{{ $t('SeaExport.BargeCYCutOffDate2') }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-show="showBargeCustomCutoff">
          <el-date-picker
            v-model="job.bargeCustomCutoff"
            :disabled="readonly"
            no="73"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.bargePOL.visible && showBargeCustomCutoff" slot="bargePOL">
        <line-label slot="label" :class="elementDict.bargePOL.isRequire ? 'blue' : ''" :label="elementDict.bargePOL.label" />
        <el-input v-model="job.bargePOL" :disabled="readonly" no="74" />
      </el-form-item>
      <el-form-item v-if="elementDict.vesselLineCode.visible" slot="vesselLineCode">
        <line-label slot="label" :class="elementDict.vesselLineCode.isRequire ? 'blue' : ''" :label="elementDict.vesselLineCode.label" />
        <el-input v-model="job.vesselLineCode" :disabled="readonly" no="75" />
      </el-form-item>
      <!--询价编号-->
      <el-form-item v-if="elementDict.inquiryPriceNo && elementDict.inquiryPriceNo.visible" slot="inquiryPriceNo">
        <line-label slot="label" :class="elementDict.inquiryPriceNo.isRequire ? 'blue' : ''" :label="elementDict.inquiryPriceNo.label" />
        <el-input no="inquiryPriceNo" :value="job.inquiryPriceNo" class="input2" disabled />
      </el-form-item>
      <!--关联港前报价单号-->
      <el-form-item v-if="elementDict.prePortQuotationNo && elementDict.prePortQuotationNo.visible" slot="prePortQuotationNo">
        <line-label slot="label" :class="elementDict.prePortQuotationNo.isRequire ? 'blue' : ''" :label="elementDict.prePortQuotationNo.label" />
        <el-input no="prePortQuotationNo" :value="job.prePortQuotationNo" class="input2" disabled />
      </el-form-item>
      <!--关联尾程报价单号-->
      <el-form-item v-if="elementDict.lastMileQuotationNo && elementDict.lastMileQuotationNo.visible" slot="lastMileQuotationNo">
        <line-label slot="label" :class="elementDict.lastMileQuotationNo.isRequire ? 'blue' : ''" :label="elementDict.lastMileQuotationNo.label" />
        <el-input no="lastMileQuotationNo" :value="job.lastMileQuotationNo" class="input2" disabled />
      </el-form-item>
      <el-form-item v-if="elementDict.containerLoadType.visible" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="job.containerLoadType"
          no="containerLoadType"
          :disabled="readonly"
          @change="containerLoadType_Change()"
        >
          <el-option value="FCL" :label="$t('CargoMsg.Cargo_FCL')" />
          <el-option value="LCL" :label="$t('CargoMsg.Cargo_DirectConsol')" />
          <el-option value="BB" :label="$t('CargoMsg.Cargo_CoLoadConsol')" />
          <el-option value="BC" label="Buyer Console" />
          <el-option value="BULK" :label="$t('CargoMsg.Cargo_BulkCargo')" />
        </el-select>
      </el-form-item>
      <template slot="seaEq">
        <el-form-item v-show="elementDict.seaEq.visible && (job.containerLoadType==='FCL'||job.containerLoadType==='BB')" label-width="0">
          <booking-sea-eq-data-grid
            ref="bookingSeaEqDataGrid"
            :value="seaEqList"
            :container-load-type="job.containerLoadType"
            :is-edit="isEdit"
            :job="job"
            :hide-soc="true"
          />
        </el-form-item>
        <el-form-item
          v-show="elementDict.seaEq.visible && (job.containerLoadType==='FCL'||job.containerLoadType==='BB')"
          label-width="0"
        >
          <el-checkbox v-model="job.soc" :disabled="readonly" :style="{marginRight:'10px'}" @change="socChange">{{ $t('SeaExport.Soc') }}</el-checkbox>
          <el-radio-group v-show="job.soc" v-model="job.socType" :disabled="readonly" no="118" :style="{marginTop: '2px', marginLeft: '25px'}">
            <el-radio :label="1">{{ $t('CargoMsg.CargoOwnerSOC') }}</el-radio>
            <el-radio :label="2">{{ $t('CargoMsg.ForwarderSOC') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <el-form-item v-show="elementDict.quantityConsignActual.visible" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.quantityContract"
            :disabled="readonly"
            no="77"
            :precision="0"
            :min="0"
            @change="quantityContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.quantityActual"
            :disabled="readonly"
            no="78"
            :precision="0"
            :min="0"
            @change="quantityActualChange"
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.weightConsignActual.visible" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.weightContract"
            :disabled="readonly"
            no="79"
            :precision="3"
            :min="0"
            @change="weightContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.weightActual"
            :disabled="readonly"
            no="80"
            :precision="3"
            :min="0"
            @change="weightActualChange"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.cubageConsignActual.visible" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.cubageContract"
            :disabled="readonly"
            no="81"
            :precision="3"
            :min="0"
            @change="cubageContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="job.cubageActual"
            :disabled="readonly"
            no="82"
            :precision="3"
            :min="0"
            @change="cubageActualChange"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.packing.visible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="83"
          :disabled="readonly"
          :default-value="job.packing"
          placeholder=" "
          @change="p=>{job.packing=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.visible" slot="insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="job.insideQuantity"
          :disabled="readonly"
          no="84"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.visible" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex">
          <el-input-number
            v-model="job.chargeWeight"
            :disabled="readonly"
            no="85"
            :controls="false"
            :precision="3"
            style="width: 100%"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.visible" slot="insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="86"
          :disabled="readonly"
          :default-value="job.insidePacking"
          placeholder=" "
          @change="p=>{job.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.measurements.visible" slot="measurements">
        <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
        <el-input
          v-model="job.measurements"
          :disabled="readonly"
          no="87"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog(elementDict.measurements.label,job.measurements,val=>{job.measurements=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salePriceRemarks.visible && job.salePrice" slot="salePriceRemarks">
        <line-label slot="label" :class="elementDict.salePriceRemarks.isRequire ? 'blue' : ''" :label="elementDict.salePriceRemarks.label" />
        <el-input v-model="job.salePriceRemarks" :disabled="readonly" no="88" type="textarea" :rows="3" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.visible" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="89"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="job.freightTerm"
          @parentCallBack="p=>{job.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTermHBL.visible" slot="freightTermHBL">
        <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
        <cargo-advance-select
          no="90"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="job.freightTermHBL"
          @parentCallBack="p=>{job.freightTermHBL=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.visible" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="91"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_IncoTerm"
          filterable
          :clearable="false"
          :default-value="job.incoTerm"
          @parentCallBack="p=>{job.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingTerm.visible" slot="bookingTerm">
        <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
        <cargo-require-select
          v-model="job.bookingTerm"
          :disabled="readonly"
          no="92"
          :options="bookingTerms"
          :label-field="isZh?'chineseName':'englishName'"
          value-field="code"
          :clearable="false"
          size="mini"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freeTime.visible" slot="freeTime">
        <line-label slot="label" :class="elementDict.freeTime.isRequire ? 'blue' : ''" :label="elementDict.freeTime.label" />
        <el-input-number v-model="job.freeTime" :disabled="readonly" no="96" :controls="false" style="width: 100%;" @input="val=>{job.freeDetention=val}" />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.visible" slot="cargoChineseName">
        <div slot="label">
          <line-label :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <br>
          <el-button
            v-show="isEdit"
            no="ChineseDescriptionOfGoods"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>job.cargoChineseName=p.commodityName)"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <cargo-textarea
          v-model="job.cargoChineseName"
          no="cargoChineseName"
          :disabled="!isEdit"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
        />
      </el-form-item>
      <template v-if="elementDict.cargoEnglishName.visible" slot="cargoEnglishName">
        <el-form-item v-show="isEdit">
          <div slot="label">
            <el-button
              no="Copy2"
              type="primary"
              @click="transcribeDialog.visible=true"
            >{{ $t('SeaExport.Copy2') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <cargo-textarea
            v-model="job.cargoEnglishName"
            no="cargoEnglishName"
            type="textarea"
            :rows="5"
            :disabled="!isEdit"
            :auto-uppercase="isUppercaseByConfig"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.hsCode.visible" slot="hsCode">
        <div slot="label">
          <line-label :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <br>
          <el-button
            v-show="isEdit"
            no="Search"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),val=>{job.hsCode=val.code})"
          >{{ $t('SeaExport.Search') }}
          </el-button>
        </div>
        <el-input
          v-model="job.hsCode"
          :disabled="readonly"
          no="hsCode"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.hsCode.labe,job.hsCode,val=>{job.hsCode=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mark.visible" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <cargo-rich-textarea
          v-model="job.mark"
          no="100"
          :text-chars="0"
          :warning-count="-1"
          :disabled="!isEdit"
          :auto-uppercase="isUppercaseByConfig"
          style="height: 65px;min-height: 65px;flex:1"
          @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
        />
      </el-form-item>
      <template v-if="elementDict.cargoCode.visible" slot="cargoCode">
        <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="101"
            :select-type="TYPE_NAMES.basic_data_CargoInformation"
            :disabled="readonly"
            filterable
            :clearable="true"
            :default-value="job.cargoCode"
            :allow-create="false"
            @parentCallBack="p=>{cargoCodeChange(p.value)}"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="job.cargoName"
            no="102"
            :disabled="!(isEdit && job.cargoCode!='' && job.cargoCode!=null) || readonly"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.customsBroker.visible" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          no="103"
          :disabled="!job.customs || readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="job.customsBroker||''"
          :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.visible" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="!job.customs || readonly"
          :select-type="TYPE_NAMES.basic_data_CustomsDeclarationType"
          filterable
          :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{job.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.haulageCompany.visible && !isSalesForSzfs" slot="haulageCompany">
        <line-label slot="label" :class="elementDict.haulageCompany.isRequire ? 'blue' : ''" :label="elementDict.haulageCompany.label" />
        <cargo-company-select
          no="104"
          :disabled="!job.landTransportation || readonly"
          :method-params="{truckCmp:true,active:true}"
          :default-value="job.carryingCmp||''"
          :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
          @change="carryingCmpChangeHandler"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.doorName.visible && job.landTransportation" slot="doorName">
        <line-label slot="label" :class="elementDict.doorName.isRequire ? 'blue' : ''" :label="elementDict.doorName.label" />
        <el-select
          v-model="truckingInfo.doorName"
          :disabled="readonly"
          no="105"
          value-key="name"
          clearable
          filterable
          :allow-create="true"
          @change="doorsChangeHandler"
        >
          <el-option
            v-for="(item,index) in doorList"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-show="elementDict.contactPerson.visible && job.landTransportation" slot="contactPerson">
        <line-label slot="label" :class="elementDict.contactPerson.isRequire ? 'blue' : ''" :label="elementDict.contactPerson.label" />
        <div style="display:flex">
          <el-input v-model="truckingInfo.doorMan" :disabled="readonly" no="106" class="short-el-input" :placeholder="$t('Payment.contactPerson')" />
          <div :class="elementDict.contactPerson.isRequire ? 'blue' : ''" style="width: 67px;padding:0 5px;font-size: 12px;text-align: right;">{{ $t('SeaExport.Tel') }}</div>
          <el-input v-model="truckingInfo.doorManTel" :disabled="readonly" no="107" class="short-el-input" :placeholder="$t('SeaExport.Tel')" />
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.doorAddr.visible && job.landTransportation" slot="doorAddr">
        <line-label slot="label" :class="elementDict.doorAddr.isRequire ? 'blue' : ''" :label="elementDict.doorAddr.label" />
        <el-input
          v-model="truckingInfo.doorAddr"
          :disabled="readonly"
          no="108"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.DoorAddress'),truckingInfo.doorAddr,val=>{truckingInfo.doorAddr=val},true,{maxChar: 0})"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.loadingDate && elementDict.loadingDate.visible && job.landTransportation" slot="loadingDate">
        <line-label slot="label" :class="elementDict.loadingDate && elementDict.loadingDate.isRequire ? 'blue' : ''" :label="elementDict.loadingDate && elementDict.loadingDate.label" />
        <el-date-picker
          v-model="truckingInfo.loadingDate"
          :disabled="readonly"
          no="loadingDate"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width:100%"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.satisfiedRequests.visible" slot="satisfiedRequests">
        <special-requests-grid
          ref="selectedSpecialRequest"
          v-model="job.satisfiedRequests"
          :is-edit="isEdit"
          :customer-id="job.customerId"
          :lob="job.lob"
          :job="job"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.visible" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="job.remarks"
          :disabled="readonly"
          no="110"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,job.remarks,val=>{job.remarks=val})"
        />
      </el-form-item>
      <!--港前商务负责人-->
      <el-form-item v-if="elementDict.prePortPlanner && elementDict.prePortPlanner.visible" slot="prePortPlanner">
        <line-label slot="label" :class="elementDict.prePortPlanner.isRequire ? 'blue' : ''" :label="elementDict.prePortPlanner.label" />
        <cargo-user-select
          no="prePortPlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="job.prePortPlanner||''"
          placeholder=" "
          @change="prePortPlannerChangeHandler"
        />
      </el-form-item>
      <!--尾程商务负责人-->
      <el-form-item v-if="elementDict.lastMilePlanner && elementDict.lastMilePlanner.visible" slot="lastMilePlanner">
        <line-label slot="label" :class="elementDict.lastMilePlanner.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlanner.label" />
        <cargo-user-select
          no="lastMilePlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="job.lastMilePlanner||''"
          placeholder=" "
          @change="lastMilePlannerChangeHandler"
        />
      </el-form-item>
      <!--港前商务负责人部门-->
      <el-form-item v-if="elementDict.prePortPlannerDepartment && elementDict.prePortPlannerDepartment.visible" slot="prePortPlannerDepartment">
        <line-label slot="label" :class="elementDict.prePortPlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerDepartment.label" />
        <cargo-department-select
          no="prePortPlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(job.prePortPlannerOffice)"
          :enables="true"
          :department-id="Number(job.prePortPlannerDepartment)"
          @change="p=>{job.prePortPlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人部门-->
      <el-form-item v-if="elementDict.lastMilePlannerDepartment && elementDict.lastMilePlannerDepartment.visible" slot="lastMilePlannerDepartment">
        <line-label slot="label" :class="elementDict.lastMilePlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerDepartment.label" />
        <cargo-department-select
          no="lastMilePlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(job.lastMilePlannerOffice)"
          :enables="true"
          :department-id="Number(job.lastMilePlannerDepartment)"
          @change="p=>{job.lastMilePlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--港前商务负责人公司-->
      <el-form-item v-if="elementDict.prePortPlannerOffice && elementDict.prePortPlannerOffice.visible" slot="prePortPlannerOffice">
        <line-label slot="label" :class="elementDict.prePortPlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerOffice.label" />
        <cargo-advance-select
          no="prePortPlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.prePortPlannerOffice||''"
          @parentCallBack="p=>{job.prePortPlannerOffice=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人公司-->
      <el-form-item v-if="elementDict.lastMilePlannerOffice && elementDict.lastMilePlannerOffice.visible" slot="lastMilePlannerOffice">
        <line-label slot="label" :class="elementDict.lastMilePlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerOffice.label" />
        <cargo-advance-select
          no="lastMilePlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.lastMilePlannerOffice||''"
          @parentCallBack="p=>{job.lastMilePlannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.visible" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="job.userDefinedField1"
          :disabled="readonly"
          no="111"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.visible" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="job.userDefinedField2"
          :disabled="readonly"
          no="112"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.visible" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="job.userDefinedField3"
          :disabled="readonly"
          no="113"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.visible" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="job.userDefinedField4"
          :disabled="readonly"
          no="114"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.labe,job.userDefinedField4,val=>{job.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.visible" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="job.taxNature"
          :disabled="readonly"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.localService.visible" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="job.warehousing"
          :disabled="readonly"
          no="1"
          style="display: block;"
          @change="loadingTerm_Change('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
        <el-checkbox
          v-model="job.landTransportation"
          :disabled="readonly"
          no="2"
          style="display: block;"
          @change="loadingTerm_Change('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
        <el-checkbox v-model="job.selfDeliver" :disabled="readonly" no="3" style="display: block;">{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
        <el-checkbox v-model="job.backUpWarehouse" :disabled="readonly" no="backUpWarehouse" style="display: block;">{{ $t('SeaExport.BackUpWarehouse') }}</el-checkbox>
        <el-checkbox v-model="job.otherService" :disabled="readonly" no="otherService">{{ $t('SeaExport.Other') }}</el-checkbox>
        <el-input v-show="job.otherService" v-model="job.otherRemark" :disabled="readonly" no="otherRemark" maxlength="10" />
      </el-form-item>
      <el-form-item v-if="elementDict.localService.visible && job.destinationPortService" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="$t('SeaExport.PortOfDestinationServices')" />
        <el-checkbox
          v-model="job.dischargingPortDoor"
          :disabled="readonly"
          no="dischargingPortDoor"
          style="display: block;"
        >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
        </el-checkbox>
        <el-checkbox
          v-model="job.destPortCustomsClearance"
          :disabled="readonly"
          no="destPortCustomsClearance"
          style="display: block;"
        >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
        </el-checkbox>
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.visible" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          :select-type="TYPE_NAMES.basic_data_TradeTerm"
          filterable
          :default-value="job.tradeTerm"
          :disabled="readonly"
          @parentCallBack="p=>{job.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freeDemurrage.visible" slot="freeDemurrage">
        <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
        <el-input-number v-model="job.freeDemurrage" :disabled="readonly" :controls="false" style="width: 100%;" no="freeDemurrage" />
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="job.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
    </tab-se-booking-UICustom-layout>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="115"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="116" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="job"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabSeBookingUICustomLayout from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabSeBookingUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabSeBooking from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabSeBooking.vue'
import StrUtils from '@/utils/StrUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabSeBookingUICustom',
  components: { cargoTextarea, tabSeBookingUICustomLayout, transcribeDialog, hsCodeSearchDialog },
  extends: tabSeBooking,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      TYPE_NAMES,
      transcribeDialog: {
        visible: false
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => {}
      },
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      operationDateData: { // 子应用操作日期
        filedLable: 'SeaExport.OperationDate',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'operationDate',
        fieldData: this.job ? this.job.customsDate : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: ''
      },
      userDefinedRoleData: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    changeDispatchingPlaceCode(data) {
      this.job.dispatchingPlaceCode = data.code
      this.changeDispatchingPlace(data.englishName, this.job.dispatchingPlaceCode)
    },
    changeDispatchingPlace(dispatchingPlace) {
      const job = this.job
      if (dispatchingPlace) {
        job.dispatchingPlace = dispatchingPlace
      }
    },
    transcribeCallback(data) {
      for (const key in data) {
        this.job[key] = data[key]
      }
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.REMOTE_SEA_BOOKING_BASIC, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.job
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (element.visible && element.isRequire) {
              if (key === 'amsCutoff') {
                if (!form.ams) {
                  continue
                }
              }
              if (key === 'agentRefNo') {
                if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
                  continue
                }
              }
              if (key === 'projectName' || key === 'projectBatch') {
                if (!this.openProjectConfig) {
                  continue
                }
              }
              if (key === 'paymentTermHBL') {
                if (form.mblOnly) {
                  continue
                }
              }
              if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
                if (!this.isAddUserDefinedRoles) {
                  continue
                }
              }
              if (key === 'shipperLine1') {
                let shipperLine = ''
                for (let i = 1; i <= 7; ++i) {
                  shipperLine += form['shipperLine' + i]
                }
                if (StrUtils.isEmpty(shipperLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
                continue
              }
              if (key === 'consigneeLine1') {
                let consigneeLine = ''
                for (let i = 1; i <= 7; ++i) {
                  consigneeLine += form['consigneeLine' + i]
                }
                if (StrUtils.isEmpty(consigneeLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
                continue
              }
              if (key === 'notifyLine1') {
                let notifyLine = ''
                for (let i = 1; i <= 7; ++i) {
                  notifyLine += form['notifyLine' + i]
                }
                if (StrUtils.isEmpty(notifyLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
                continue
              }
              if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
                continue
              }
              if (key.startsWith('shipperCode') || key.startsWith('consigneeCode') || key.startsWith('notifyCode')) {
                continue
              }
              if (key === 'transferPortCode') {
                if (form.transfering && StrUtils.isEmpty(form.transferPortCode)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
              } else if (key === 'designationAgent') {
                if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
              } else if (key === 'bargeCustomCutoff') {
                if (StrUtils.isEmpty(form[key])) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.BargeCYCutOffDate2')]), 'tabSeBooking')
                }
              } else if (key === 'taxNature') {
                if (form[key] === '' || form[key] === null) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
                }
              } else {
                if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSeBooking')
                }
              }
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.visible && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabSeBooking')
          }
          for (const seaEq of this.seaEqList) {
            if (!seaEq.eqQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabSeBooking')
            }
          }
        }
      }
      if (this.elementDict.haulageCompany && this.elementDict.haulageCompany.visible && this.elementDict.haulageCompany.isRequire) {
        if (!this.form.carryingCmp && !this.isSalesForSzfs) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.haulageCompany.label]), 'tabSeBooking')
        }
      }
      if (this.elementDict.doorName.visible && this.elementDict.doorName.isRequire) {
        if (StrUtils.isEmpty(this.truckingInfo.doorName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorName.label]), 'tabSeBooking')
        }
      }
      if (form.landTransportation) {
        if (this.elementDict.contactPerson.visible && this.elementDict.contactPerson.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorMan)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.contactPerson.label]), 'tabSeBooking')
          }
          if (StrUtils.isEmpty(this.truckingInfo.doorManTel)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Tel')]), 'tabSeBooking')
          }
        }
        if (this.elementDict.doorAddr.visible && this.elementDict.doorAddr.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorAddr)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorAddr.label]), 'tabSeBooking')
          }
        }
        if (this.elementDict.loadingDate && this.elementDict.loadingDate.visible && this.elementDict.loadingDate.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.loadingDate)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.loadingDate.label]), 'tabSeBooking')
          }
        }
      }
      if (this.elementDict.satisfiedRequests && this.elementDict.satisfiedRequests.visible && this.elementDict.satisfiedRequests.isRequire) {
        if (StrUtils.isEmpty(form.satisfiedRequests)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.satisfiedRequests.label]), 'tabSeBooking')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setOperationDateData() {
      this.operationDateData.fieldData = this.job.customsDate
      this.operationDateData.disabled = this.readonly
      console.log('主应用发送OperationDate:', this.operationDateData)
      microApp.forceSetData('child-operation-date-se', this.operationDateData)
    },
    operationDateDataChange(e) {
      console.log('主应用获取OperationDate:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateData()
        } else {
          this.job.customsDate = e.detail.data.fieldData
        }
      }
    },
    setUserDefinedRoleData() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleData }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-remoteBooking-se-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleData }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-remoteBooking-se-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChange(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleData()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .job-no-color.el-input {
  .el-input__inner {
    background: #ffffcc !important;
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
/deep/ .also-notify {
  width: 310px;
  .el-textarea__inner {
    height: 230px;
  }
}
/deep/ .port-item {
  min-width: auto;
}
</style>
